export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'ip', label: 'IP', minWidth: '100', sortable: true},
    {prop: 'sourceLabel', label: '渠道', minWidth: '100'},
    {prop: 'repeatCount', label: '重复次数', minWidth: '50', sortable: true}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
